import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { LzTFunctionSimple } from "@lz/typings/types";

export interface LzPImportParamsDialog {
    children?: React.ReactNode,
    show?: boolean,
    onApply?: LzTFunctionSimple,
    onReset?: LzTFunctionSimple,
    onClose?: LzTFunctionSimple,
}

const LzXImportParamsDialog = (props: LzPImportParamsDialog) => {

    const onClose = () => {
        // Call reset so that any changes you did are reverted
        if (props.onReset) {
            props.onReset();
        }

        // Then call close
        if (props.onClose) {
            props.onClose();
        }
    };

    return (
        <Dialog open={!!props.show} fullWidth onClose={() => onClose()}>

            <DialogTitle>Import Parameters</DialogTitle>

            <DialogContent className="lz-form">
                {props.children}
            </DialogContent>

            <DialogActions>
                <Button onClick={() => onClose()}>Close</Button>
                <Button onClick={props.onReset}>Reset</Button>
                <Button onClick={props.onApply} color="primary" variant="contained">Apply</Button>
            </DialogActions>

        </Dialog>
    );
};

export default LzXImportParamsDialog;
